import { Controller } from "@hotwired/stimulus";

export class FiltersController extends Controller {
  static targets = ["panel", "toggleButton"];
  static values = {
    activeClass: { type: String, default: "filters-panel--open" },
  };

  connect() {
    this.isOpen = false;
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.panelTarget.classList.toggle(this.activeClassValue, this.isOpen);

    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute(
        "aria-expanded",
        this.isOpen ? "true" : "false",
      );
    }
  }

  close() {
    this.isOpen = false;
    this.panelTarget.classList.remove(this.activeClassValue);

    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute("aria-expanded", "false");
    }
  }
}
